import AvailabilityService from '../api/availability-service'

export default {
    state: {
        pending: null,
        extras: [],
        promoApplied: false
    },
    mutations: {
        setExtraAvailability (state, extras) {
            state.extras = extras.map(e => {
                e = {
                    ...e,
                    totalPrice: 0
                }
                e.offerLines = e.offerLines.map(o => ({
                    ...o,
                    quantity: 0,
                    totalPrice: 0
                }))
                return e
            })
        },
        updateExtraBySummary (state, summary) {
            const extra = state.extras.find(e => e.id === summary.extraId)
            if (extra !== undefined) {
                const offerLine = extra.offerLines.find(o => o.id === summary.offerLineId)
                if (offerLine !== undefined) {
                    offerLine.quantity = summary.quantity
                    offerLine.totalPrice = offerLine.totalPricePerUnit * summary.quantity
                }
                extra.totalPrice = extra.offerLines.reduce((accumulator, o) => {
                    return accumulator + o.totalPrice
                }, 0)
            }
        },
        resetExtras (state) {
            state.extras = []
            state.promoApplied = false
            state.lastQuery = null
        },
        setPending (state, isPending) {
            state.pending = isPending
        },
        setPromoApplied (state, promoApplied) {
            state.promoApplied = promoApplied
        }
    },
    actions: {
        async getExtraAvailability (context, query) {
            context.commit('setPending', true)
            const previousExtras = [...context.state.extras]
            const response = await AvailabilityService.getExtraAvailability(query).catch((error) => {
                return {
                    data: {
                        error: error,
                        extraAvailabilities: [],
                        promotionApplied: false
                    }
                }
            })
            context.commit('setExtraAvailability', response.data.extraAvailabilities)
            context.commit('setPromoApplied', response.data.promotionApplied)
            previousExtras.forEach(e => e.offerLines
                .forEach(o => context.commit('updateExtraBySummary', {
                    extraId: e.id,
                    offerLineId: o.id,
                    quantity: o.quantity
                }))
            )
            context.commit('setPending', false)
        },
        async getFastTrackAvailability (context, query) {
            context.commit('setPending', true)
            const previousExtras = [...context.state.extras]
            const response = await AvailabilityService.getFastTrackAvailability(query)
            context.commit('setExtraAvailability', response.data.extraAvailabilities)
            context.commit('setPromoApplied', response.data.promotionApplied)
            previousExtras.forEach(e => e.offerLines
                .forEach(o => context.commit('updateExtraBySummary', {
                    extraId: e.id,
                    offerLineId: o.id,
                    quantity: o.quantity
                }))
            )
            context.commit('setPending', false)
        }
    },
    getters: {
        selectedExtrasTotalQuantity (state) {
            let total = 0
            state.extras.forEach((extra) => {
                extra.offerLines.forEach((offerLine) => {
                    total += offerLine.quantity
                })
            })
            return total
        }
    }
}
